import { createFileRoute } from "@tanstack/react-router";

import { ApplyPage } from "@/features/apply/apply-page";

/** 大学・会員企業（応募側）の利用申込。アカウント未発行の人が使うため認証ガードは付けない。 */
export const Route = createFileRoute("/apply/member")({
  component: () => <ApplyPage kind="MEMBER_APPLICATION" />,
});
